import * as React from "react";
import * as moment from "moment";
import { Panel } from "react-bootstrap";

import { AppShape, EmploymentShape } from "@eave/shared/types/api";

import AdditionalIncomeSection from "../../employments/AdditionalIncomeSection";
import BasePaySection from "../../employments/BasePaySection";
import MilitaryIncomeSection from "../../employments/MilitaryIncomeSection";

const humanize = require("underscore.string/humanize");

interface EmploymentSectionProps {
  dispatch?: Function;
  app: AppShape;
  employment: EmploymentShape;
  update: Function;
}

export default class EmploymentSection extends React.Component<EmploymentSectionProps, any> {
  updateAggregation(index, field, value) {
    this.props.update(index, field, value);
  }

  render() {
    const { app, employment } = this.props;

    const isMilitary = !!employment.military_income;

    return (
      <Panel className="employments" defaultExpanded>
        <Panel.Heading>
          <Panel.Title toggle>
            {isMilitary ? `US military income (${employment.name})` : employment.name}
          </Panel.Title>
        </Panel.Heading>
        <Panel.Collapse>
          <Panel.Body>
            <dl className="dl-horizontal salaried_income__summary">
              <dt>Borrower</dt>
              <dd>{employment.borrower_entity}</dd>
              <dt>Employer</dt>
              <dd>{employment.name}</dd>
              <dt>Employment Type</dt>
              <dd>{humanize(employment.employment_type)}</dd>
              <dt>Employment Start Date</dt>
              <dd>
                {employment.start_date && moment.utc(employment.start_date).format("MM/DD/YYYY")}
              </dd>
            </dl>
            {employment.income_aggregations &&
              employment.income_aggregations.length > 0 &&
              employment.income_aggregations.map((income_aggregation, i) => {
                if (income_aggregation.pay_type === "base_pay") {
                  return (
                    <BasePaySection
                      key={i}
                      app={app}
                      employment={employment}
                      data={income_aggregation}
                      updateAggregation={this.updateAggregation.bind(this, i)}
                    />
                  );
                }
                return (
                  <AdditionalIncomeSection
                    key={i}
                    summarySection="bonus_summary"
                    app={app}
                    employment={employment}
                    data={income_aggregation}
                    updateAggregation={this.updateAggregation.bind(this, i)}
                  />
                );
              })}
            {isMilitary && <MilitaryIncomeSection militaryIncome={employment.military_income} />}
          </Panel.Body>
        </Panel.Collapse>
      </Panel>
    );
  }
}
